import { createApi } from "@reduxjs/toolkit/query/react";
import { baseApiQuery } from "../../../shared/api";
import { BaseResponse } from "../../../shared/types";
import {
  ClubLogoUploadResponse,
  ClubResponse,
  ClubsResponse,
  CreateClubRequest,
  SetResidentClubsRequest,
  UpdateClubRequest,
} from "./types";

export const clubsApi = createApi({
  reducerPath: "clubsApi",
  baseQuery: baseApiQuery,
  tagTypes: ["Clubs", "Residents"],
  endpoints: (builder) => ({
    getClubs: builder.query<ClubsResponse, void>({
      query: () => "/admin/clubs",
      providesTags: ["Clubs"],
    }),

    createClub: builder.mutation<ClubResponse, CreateClubRequest>({
      query: (body) => ({
        url: "/admin/clubs",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Clubs"],
    }),

    updateClub: builder.mutation<
      ClubResponse,
      { id: number; body: UpdateClubRequest }
    >({
      query: ({ id, body }) => ({
        url: `/admin/clubs/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Clubs"],
    }),

    deleteClub: builder.mutation<BaseResponse, number>({
      query: (id) => ({
        url: `/admin/clubs/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Clubs", "Residents"],
    }),

    uploadClubLogo: builder.mutation<
      ClubLogoUploadResponse,
      { id: number; file: FormData }
    >({
      query: ({ id, file }) => ({
        url: `/admin/clubs/${id}/logo`,
        method: "POST",
        body: file,
      }),
      invalidatesTags: ["Clubs"],
    }),

    deleteClubLogo: builder.mutation<BaseResponse, number>({
      query: (id) => ({
        url: `/admin/clubs/${id}/logo`,
        method: "DELETE",
      }),
      invalidatesTags: ["Clubs"],
    }),

    setResidentClubs: builder.mutation<
      BaseResponse,
      { id: string; body: SetResidentClubsRequest }
    >({
      query: ({ id, body }) => ({
        url: `/admin/communities/${id}/clubs`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Residents"],
    }),
  }),
});

export const {
  useGetClubsQuery,
  useCreateClubMutation,
  useUpdateClubMutation,
  useDeleteClubMutation,
  useUploadClubLogoMutation,
  useDeleteClubLogoMutation,
  useSetResidentClubsMutation,
} = clubsApi;
